import { responseTags } from "~/Commons";

export const DIFY_APITEST_MESSAGE_END_PREFIX = responseTags.messageEnd;

/**
 * 応答チャンクが終了メッセージかどうかを判定する
 * @param chunk 応答チャンク
 * @return 終了メッセージかどうか
 */
export const isMessageEndChunk = (chunk: string) => {
  return chunk.startsWith(DIFY_APITEST_MESSAGE_END_PREFIX);
};

/**
 * 終了メッセージからメッセージIDを取り出す
 * @param chunk 応答チャンク
 * @return メッセージID
 */
export const extractMessageId = (chunk: string) => {
  return chunk.split("/")[1] ?? "";
};
